import IOrder from "../../../../models/IOrder";
import OwLabel from "../../OwLabel/OwLabel";
import OwButton from "../../OwButton/OwButton";
import {useContext, useEffect} from "react";
import {QbPaymentContext} from "../../../../contexts/QbPaymentContext";

type Props = {
    orderModel: IOrder,
    onlyCollectCcToUse: boolean,
    confirmFn: (refresh?: boolean) => void;
};

export const QuickBooksPaymentConfirmationDetail = (props: Props) => {
    const qbPaymentContext = useContext(QbPaymentContext);

    useEffect(() => {
        qbPaymentContext.setIsLoading(false);
    }, []);

    return <div className={"QuickBooksPaymentConfirmationDetail d-flex flex-column justify-content-center align-items-center h-100"}>
        {props.onlyCollectCcToUse? <OwLabel title={"successfully_updated_card_to_use"}/> : <OwLabel className={"text-success"} title={"successfully_processed_payment"}/>}
        <div className={"mt-3"}><OwButton title={"return_to_order"} fn={() => { props.confirmFn(true) }}/></div>
    </div>;
};
